import { useState,useEffect } from "react"
import africasaLogo from '../assets/africasa-logo.png'
// import { toast } from "react-toastify"
import Swal from "sweetalert2"
import { authApi } from "../api/authApi"
import { Spin } from 'antd';
import { Auth } from "../utils/Auth"
import { replace, useNavigate } from "react-router"




const LoginView = () => {
  const navigate =  useNavigate()

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [loading, setLoading] = useState(false)
    const [errorMsg, setErrorMsg] = useState('')

    const abortController = new AbortController()

    useEffect(() => {        
        
        if(Auth.isLoggedIn()) navigate('/',{replace:true});
    },[])
    
    // const toast = Toaster
    if (Auth.isLoggedIn()) return null;

    const handleLogin = async (e) => {
        e.preventDefault();

        setLoading(true)
        const payload = {
            email:email,
            password:password,
        }

        
        if(email === '' || password === ''){
          // toast.error('Email et Mot de passe obligatoires')
          setLoading(false)

          return Swal.fire({
            title: 'Champs obligatoires!',
            text: 'Email et Mot de passe obligatoires',
            icon: 'error',
          })
          // console.log('Email et Mot de passe obligatoires')
        }
       

        const res =  await authApi.login(JSON.stringify(payload),abortController.signal)
            
        if(!res.success){
          setLoading(false)

          setErrorMsg(res.message)

          return Swal.fire({
            title: 'Echec de connexion!',
            text: res.message,
            icon: 'error'
          })
        }
        console.log(res.data)

        Auth.setSessionToken(res.data.token)
        Auth.setUser({
            userId:res.data.admin.id,
            user:res.data.admin
        })

        console.log(Auth.getUser())

        navigate('/',{replace:true})
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-lg shadow-md">
        <img src={africasaLogo} className='w-32 m-auto mb-6' alt='Africasa Auto logo'></img>
        
        <h2 className="text-2xl font-bold text-center text-africasa-secondary">Connexion</h2>
        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-africasa-primary">
              Email
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              // required
              className="w-full px-4 py-2 mt-2 text-sm text-gray-700 bg-gray-200 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500"
              placeholder="Entrez votre email"
            />
          </div>
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-africasa-primary">
              Mot de passe
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              // required
              className="w-full px-4 py-2 mt-2 text-sm text-gray-700 bg-gray-200 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500"
              placeholder="Entrez votre mot de passe"
            />
          </div>
          <button
            type="submit"
            className="w-full px-4 py-2 text-white bg-africasa-secondary rounded-md hover:bg-africasa-primary focus:outline-none focus:bg-africasa-primary"
          >

            Se connecter {loading && <Spin size='small' className='text-mk-secondary'></Spin> }
          </button>
        </form>
        
      </div>
    </div>
    )
}

export default LoginView